import { Text, css, styled, Box } from '@chilipiper/design-system'
import { stylesChatLinks } from '../../styles'

export const StyledTextContainer = styled(Box)<{ isOwnMessage: boolean }>`
  line-height: 1;
  ${({ theme, isOwnMessage }) =>
    isOwnMessage
      ? css`
          color: rgb(var(--primary-contrast-color));
          background-color: rgb(var(--primary-color));
        `
      : css`
          color: ${theme.colors['fg/major']};
          background: ${theme.colors['bg/section-emphasis']};
        `}
`

export const StyledText = styled(Text)`
  display: block;
  white-space: pre-wrap;
  word-break: break-word;
  color: inherit;

  :has(*) {
    white-space: normal;
  }

  h1 {
    font-size: 1.5em;
  }

  h2 {
    font-size: 1.25em;
  }

  h3 {
    font-size: 1.125em;
  }

  h4 {
    font-size: 1em;
  }

  h5 {
    font-size: 0.875em;
  }

  h6 {
    font-size: 0.75em;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin-block: 0.5em;
  }

  * {
    margin: revert;
    padding: revert;
    line-height: initial;
    list-style-type: revert;
  }

  ul,
  ol {
    margin-block: 0.5em;
    padding-inline-start: 1.5em;
  }

  *:is(ol, ul) :is(ol, ul) {
    margin-block: 0;
  }

  li {
    padding-block: 0.125em;
  }

  del {
    text-decoration: line-through;
  }

  code {
    background: ${({ theme }) => theme.colors['bg/accent']};
    border-radius: 8px;
    color: ${({ theme }) => theme.colors['fg/major-on-color']};
    padding: 2px 4px;
  }

  pre {
    overflow-x: auto;
  }

  pre code {
    overflow-x: auto;
    display: block;
    padding: 0.5em;
  }

  blockquote {
    padding-block: 0.5em;
    margin-block: 0.5em;
    margin-inline: 0;
    border-left: 2px solid ${({ theme }) => theme.colors['fg/action']};
    background-color: ${({ theme }) => theme.colors['bg/action']};
    padding-left: 1em;

    *:first-child {
      margin-block-start: 0;
    }

    *:last-child {
      margin-block-end: 0;
    }
  }

  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
    border-collapse: collapse;
  }

  td,
  th {
    padding: 0.25em 0.5em;
  }

  td + td,
  th + th {
    border-left: 1px solid ${({ theme }) => theme.colors['fg/minor']};
  }

  thead {
    border-bottom: 1px solid ${({ theme }) => theme.colors['fg/minor']};
  }

  tr + tr {
    border-top: 1px solid ${({ theme }) => theme.colors['fg/minor']};
  }

  p {
    padding: 0;
    color: inherit;
    font-weight: inherit;
    font-size: inherit;
    line-height: inherit;
    letter-spacing: inherit;
  }

  & > *:first-child {
    margin-block-start: 0;
  }

  & > *:last-child {
    margin-block-end: 0;
  }

  ${stylesChatLinks}
`
